

export const pushContentAnnounceHtmlContent = (v, contentCode, name, linkname, contentType = 'contentAnnounce') => {
  let params = {
    'type': contentType,
    'contentCode': contentCode,
    'name': name,
    'linkname': `${linkname}`
  }
  v.pushRouter({
    path: '/htmlContent',
    query: params
  })
}

export const pushModuleAnnounceHtmlContent = (v, moduleCode, name, linkname, contentType = 'contentAnnounce') => {
  let params = {
    'type': contentType,
    'moduleCode': moduleCode,
    'name': name,
    'linkname': `${linkname}`
  }
  v.pushRouter({
    path: '/announcement',
    query: params
  })
}




// WEBPACK FOOTER //
// ./src/util/navUtils.js